/** @typedef {'view' | 'fork' | 'edit'} HistoryOpenMode */

export const HISTORY_OPEN_VIEW = 'view';
export const HISTORY_OPEN_FORK = 'fork';
export const HISTORY_OPEN_EDIT = 'edit';

export const HISTORY_OPEN_MODE_OPTIONS = [
  {
    id: HISTORY_OPEN_VIEW,
    title: 'Просмотр',
    description: 'Параметры и результаты только для чтения.',
    consequence: 'История и пересчёт не изменятся.',
    icon: 'fas fa-eye',
  },
  {
    id: HISTORY_OPEN_FORK,
    title: 'Новый расчёт на основе этого',
    description: 'Копия параметров для нового сеанса.',
    consequence: 'В истории появится новая строка; эта запись останется без изменений.',
    icon: 'fas fa-copy',
  },
  {
    id: HISTORY_OPEN_EDIT,
    title: 'Изменить этот расчёт',
    description: 'Пересчёт в том же сеансе.',
    consequence: 'Обновятся записи этого расчёта; при смене структуры или модели можно оставить лишние строки в сеансе.',
    icon: 'fas fa-edit',
  },
];

/**
 * @param {string|null|undefined} mode
 * @returns {boolean}
 */
export function isHistoryViewMode(mode) {
  return mode === HISTORY_OPEN_VIEW;
}

/**
 * @param {string|null|undefined} mode
 * @returns {boolean}
 */
export function isHistoryEditMode(mode) {
  return mode === HISTORY_OPEN_EDIT;
}
